<script setup lang='ts'>
import { LOAD_STATUS } from '@qcwp/common'
import { useCascaderModel } from './hook'
import type { ModelResponse } from '~~/src/server/modules/car/types'

const props = withDefaults(defineProps<{
  seriesId?: string
  modelId?: string
  canCustomize?: boolean
  customizeModelName?: string
}>(), {
  canCustomize: false,
  customizeModelName: '',
})
const emits = defineEmits({
  select: (data: ModelResponse) => true,
})

function select(data: ModelResponse) {
  emits('select', data)
}

const {
  list,
  loadStatus,
  getModelList,
} = useCascaderModel()

const carModelName = ref(props.customizeModelName)

function customSelect() {
  if (!list.value)
    return select({ id: '-1', carModelName: carModelName.value } as any)

  for (const year in list.value.modelsYears) {
    const model = list.value.modelsYears[year].find(v => v.carModelName === carModelName.value)
    if (model)
      return select(model)
  }

  return select({ id: '-1', carModelName: carModelName.value } as any)
}
let stops = [
  watch(() => props.customizeModelName, () => {
    carModelName.value = props.customizeModelName
  }, { immediate: true }),
  watch(() => props.seriesId, () => {
    props.seriesId && getModelList(props.seriesId)
  }, { immediate: true }),
]
onUnmounted(() => {
  stops.forEach(v => v?.())
  stops = null!
})
</script>

<template>
  <div class="flex flex-col h-full pb-40 pr-3 items-start px-3">
    <template v-if="(loadStatus === LOAD_STATUS.END) && list && list.years.length">
      <ul v-if="list">
        <li v-for="year in list.years" :key="year">
          <div class="leading-10 font-bold">
            {{ year }}
          </div>
          <div v-if="(list.modelsYears[year] && list.modelsYears[year].length)" class="flex flex-wrap gap-3">
            <div
              v-for="v in list.modelsYears[year]" :key="v.id"
              class="px-2 py-1 cursor-pointer  rounded-sm "
              :class="[v.id === modelId ? 'active bg-primary text-white hover:text-white' : 'hover:text-primary bg-gray-100']"
              @click="select(v)"
            >
              {{ v.carModelName }}
            </div>
          </div>
        </li>
      </ul>
    </template>
    <div v-else-if="(loadStatus === LOAD_STATUS.LOADING)" class="py-5 flex items-center  justify-center w-full">
      <van-loading size="16" mr-2 />
      <span ml-2>加载中...</span>
    </div>
    <div v-else-if="(loadStatus === LOAD_STATUS.ERROR) && props.seriesId" class="flex flex-col items-center w-full py-5">
      <p text-4 text-gray-400>
        加载失败
      </p>
      <n-button
        mt-3
        strong secondary type="primary"
        @click="getModelList(props.seriesId)"
      >
        重新加载
      </n-button>
    </div>
    <div v-else class="flex flex-col items-center w-full py-5">
      <base-empty text="暂无相关车型" />
    </div>
    <div v-if="canCustomize" class="fixed bottom-0 bg-white py-2 w-[calc(100%-2em)] border-t-1 border-slate-2">
      <div class="leading-10 text-gray-5">
        <span font-bold mr-1>无相关车型?</span>
        <span class="text-2.5 mt-1 text-gray-4">手动输入相关车型名称</span>
      </div>
      <div class="flex items-center">
        <input
          v-model="carModelName" type="text" placeholder="手动填写车型名称"
          class="border-1 border-slate-3 px-3 py-1 rounded-md flex-grow"
        >
        <button
          class="block ml-3 flex-shrink-0 px-sm py-1 rounded-sm bg-blue-5 text-white md:px-lg"
          @click="customSelect"
        >
          确定
        </button>
      </div>
      <div>
        <span class="text-2.5 mt-1 text-gray-4 text-end">*只保存车系选择数据请直接点击确认按钮</span>
      </div>
    </div>
  </div>
</template>
